import { AsyncPipe } from "@angular/common";
import { ChangeDetectionStrategy, Component } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { NewUiButton } from "@ankaadia/ankaadia-shared-frontend";
import { FieldType, FormlyFieldConfig, FormlyModule } from "@ngx-formly/core";
import { FormlySelectModule, FormlySelectOption } from "@ngx-formly/core/select";
import { Message } from "primeng/message";
import { Popover } from "primeng/popover";
import { Tooltip } from "primeng/tooltip";
import { NewUiDropdownComponent } from "../../shared/form/dropdown/new-ui-dropdown.component";
import { NewUiInputtextComponent } from "../../shared/form/inputtext/new-ui-inputtext.component";
import { NewUiWrapperReadonlyComponent } from "../../shared/form/wrapper-readonly/new-ui-wrapper-readonly.component";
import { NewUiFormElementMapModule } from "../../shared/from-element-map/new-ui-form-element-map.module";
import { TestIdDirective } from "../../shared/test-id/test-id.directive";

@Component({
  selector: "new-ui-formly-competency",
  templateUrl: "./new-ui-formly-competency.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NewUiDropdownComponent,
    ReactiveFormsModule,
    FormlyModule,
    FormlySelectModule,
    NewUiFormElementMapModule,
    TestIdDirective,
    NewUiButton,
    Message,
    Popover,
    AsyncPipe,
    NewUiWrapperReadonlyComponent,
    NewUiInputtextComponent,
    Tooltip,
  ],
})
export class NewUiFormlyCompetencyComponent extends FieldType {
  maxLabelLength = 50;

  get isShortLabel(): boolean {
    return this.showShortLabel();
  }

  get shortLabel(): string {
    if (!this.showShortLabel()) return this.props.label;
    return this.props.label.slice(0, this.maxLabelLength) + "...";
  }

  get additionalInformation(): FormlyFieldConfig | null {
    return this.props.additionalInformationKey ? this.field.parent.get(this.props.additionalInformationKey) : null;
  }

  getValueLabel(options: FormlySelectOption[], value: string): string {
    return options?.find((x) => x.value === value)?.label;
  }

  private showShortLabel(): boolean {
    return (this.props.label?.length || 0) > this.maxLabelLength;
  }
}
